/* Glowli local favorites - retained on this browser, not synced with Shopify accounts. */
(function () {
  'use strict';
  const KEY = 'glowli-wishlist-v1';
  const MAX_ITEMS = 80;
  const pathFor = value => {
    if (typeof value !== 'string') return '';
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return '';
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+/.test(url.pathname)) return '';
      return url.pathname;
    } catch (_) { return ''; }
  };
  const load = () => {
    try {
      const data = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(data)) return [];
      return data.filter(item => item && typeof item.handle === 'string' &&
        typeof item.title === 'string' && pathFor(item.url))
        .slice(0, MAX_ITEMS);
    } catch (_) { return []; }
  };
  let items = load();
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (_) {}
  }
  function has(handle) { return items.some(item => item.handle === handle); }
  function updateButtons() {
    document.querySelectorAll('[data-glowli-wishlist-toggle]').forEach(button => {
      const yes = has(button.dataset.glowliHandle);
      button.setAttribute('aria-pressed', String(yes));
      const title = button.dataset.glowliTitle || 'ce produit';
      button.setAttribute('aria-label', (yes ? 'Retirer ' : 'Ajouter ') + title +
        (yes ? ' de mes coups de cœur' : ' à mes coups de cœur'));
      button.title = yes ? 'Retirer des coups de cœur' : 'Ajouter aux coups de cœur';
      if (button.classList.contains('glowli-heart--detail')) {
        const caption = button.querySelector('span');
        if (caption) caption.textContent = yes ? 'Retirer de mes coups de cœur' : 'Ajouter à mes coups de cœur';
      }
    });
    document.querySelectorAll('[data-glowli-wishlist-count]').forEach(el => {
      el.textContent = String(items.length);
      el.hidden = !items.length;
    });
    document.querySelectorAll('[data-glowli-wishlist-header]').forEach(el => {
      el.setAttribute('aria-label', 'Mes coups de cœur, ' + items.length + ' produit' +
        (items.length === 1 ? '' : 's'));
    });
  }
  function renderList() {
    document.querySelectorAll('[data-glowli-wishlist-page]').forEach(page => {
      const list = page.querySelector('[data-glowli-wishlist-list]');
      const empty = page.querySelector('[data-glowli-wishlist-empty]');
      if (!list || !empty) return;
      list.replaceChildren();
      empty.hidden = items.length > 0;
      items.forEach(item => {
        const card = document.createElement('article');
        card.className = 'glowli-wishlist-page__card';
        const photoLink = document.createElement('a');
        photoLink.className = 'glowli-wishlist-page__photo';
        photoLink.href = pathFor(item.url);
        photoLink.setAttribute('aria-label', item.title);
        if (typeof item.image === 'string' && /^https?:\/\//.test(item.image)) {
          const photo = document.createElement('img');
          photo.src = item.image; photo.loading = 'lazy'; photo.alt = item.title;
          photoLink.appendChild(photo);
        }
        const info = document.createElement('div');
        info.className = 'glowli-wishlist-page__card-info';
        const titleLink = document.createElement('a');
        titleLink.href = pathFor(item.url);
        titleLink.textContent = item.title;
        const price = document.createElement('div');
        price.className = 'glowli-wishlist-page__price';
        price.textContent = item.price || '';
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'glowli-wishlist-page__remove';
        remove.textContent = 'Retirer des favoris';
        remove.setAttribute('aria-label', 'Retirer ' + item.title + ' de mes coups de cœur');
        remove.addEventListener('click', () => { items = items.filter(i => i.handle !== item.handle); changed(); });
        info.append(titleLink, price, remove);
        card.append(photoLink, info);
        list.appendChild(card);
      });
    });
  }
  function changed() {
    save(); updateButtons(); renderList();
  }
  document.addEventListener('click', e => {
    const button = e.target.closest('[data-glowli-wishlist-toggle]');
    if (!button) return;
    e.preventDefault(); e.stopPropagation();
    const handle = button.dataset.glowliHandle;
    const url = pathFor(button.dataset.glowliUrl);
    if (!handle || !url) return;
    if (has(handle)) items = items.filter(item => item.handle !== handle);
    else {
      items.unshift({
        handle, url,
        title: button.dataset.glowliTitle || '',
        image: button.dataset.glowliImage || '',
        price: button.dataset.glowliPrice || ''
      });
      items = items.slice(0, MAX_ITEMS);
    }
    changed();
  }, true);
  document.addEventListener('DOMContentLoaded', changed, { once: true });
  document.addEventListener('shopify:section:load', changed);
  window.addEventListener('storage', e => { if (e.key === KEY) { items = load(); updateButtons(); renderList(); } });
  if (document.readyState !== 'loading') changed();
})();